"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Details = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = __importDefault(require("lodash"));
var react_i18next_1 = require("react-i18next");
var Details = function (_a) {
    var data = _a.data, columns = _a.columns, showMore = _a.showMore;
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: columns.map(function (col, i) {
            var x = 'grid grid-cols-2 pb-3 space-x-2';
            var value = lodash_1.default.get(data, col.field);
            if (col.formatter)
                value = col.formatter(data);
            if (col.detailsClassNames)
                x = col.detailsClassNames;
            if (showMore && showMore < i)
                return undefined;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "grid ".concat(x), children: [(0, jsx_runtime_1.jsx)("p", { className: "text-lg text-gray-900", children: t(col.text) }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg text-gray-color", children: value || '-' })] }, col.text));
        }) }));
};
exports.Details = Details;
